/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetOrganizationPaymentBillingTransactionsResponseDataFromJSON, GetOrganizationPaymentBillingTransactionsResponseDataToJSON } from './GetOrganizationPaymentBillingTransactionsResponseData';
export function GetOrganizationPaymentBillingTransactionsResponseFromJSON(json) {
    return GetOrganizationPaymentBillingTransactionsResponseFromJSONTyped(json, false);
}
export function GetOrganizationPaymentBillingTransactionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: GetOrganizationPaymentBillingTransactionsResponseDataFromJSON(json['data'])
    };
}
export function GetOrganizationPaymentBillingTransactionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetOrganizationPaymentBillingTransactionsResponseDataToJSON(value.data)
    };
}
